import styled from 'styled-components';

import { Body as BaseBody } from '../../styles';

export {
  CloseButton,
  DetailsHeader,
  Footer,
  Header,
  Properties,
  Property,
  PropertyLabel,
  PropertyValue,
  Title,
} from '../../styles';

export const Body = styled(BaseBody)`
  flex: 1;
`;
